export type PublicEnvKey =
  | 'VITE_SUPABASE_URL'
  | 'VITE_SUPABASE_ANON_KEY'
  | 'VITE_STRIPE_PUBLISHABLE_KEY'
  | 'VITE_VAPID_PUBLIC_KEY';

export function getPublicEnv(key: PublicEnvKey): string | undefined {
  const runtimeValue = typeof window !== 'undefined' ? window.__PAIRTAB_ENV__?.[key] : undefined;
  if (typeof runtimeValue === 'string' && runtimeValue.trim().length > 0) {
    return runtimeValue;
  }

  const buildValue = import.meta.env[key];
  if (typeof buildValue === 'string' && buildValue.trim().length > 0) {
    return buildValue;
  }

  return undefined;
}
